import React, { useState } from "react";
import PropTypes from "prop-types";
import InnerFollowDialog from "./InnerFollowDialog";
import { Dialog } from "discover.medical.react-component-library";
import { useFollowDialogStore, SubscribeToAll } from "./FollowDialogContext";

const FollowDialog = ({ onRequestClose, onSave, modalData }) => {
  const [{ isOpen, saveData }] = useFollowDialogStore(SubscribeToAll);
  const [subscriptionType, setSubscriptionType] = useState("");
  const onOptionChange = (e) => setSubscriptionType(e.target.value);

  return (
    <Dialog
      data-testid={`follow-dialog-container`}
      onRequestClose={(e) => {
        onRequestClose(e);
        setSubscriptionType("");
      }}
      isOpen={isOpen}
      maxWidth="sm"
    >
      <InnerFollowDialog
        onSave={() => {
          onSave(saveData, subscriptionType);
          setSubscriptionType("");
        }}
        onOptionChange={onOptionChange}
        onRequestClose={(e) => {
          onRequestClose(e);
          setSubscriptionType("");
        }}
        selectedOption={subscriptionType}
        modalData={modalData}
      />
    </Dialog>
  );
};

FollowDialog.propTypes = {
  onRequestClose: PropTypes.func,
  onSave: PropTypes.func,
  modalData: PropTypes.object,
};

FollowDialog.displayName = "FollowDialog";

export default FollowDialog;
